const initialState = {
  html: '',
  css: null
}

export default function landingPage(state = initialState, action) {
  switch (action.type) {
    case 'fetchLandingPageContentSuccess':
      return {
        ...state,
        html: action.payload.html,
        css: action.payload.css
      }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./common/reducers/landingPage.js